<template>
  <div class="notice-pc">
    <div class="df both-side">
      <div class="title">通知中心</div>

      <a-space>
        <a-radio-group
          v-model:value="requestPayload.messageSort"
          @click="handleSearch"
        >
          <a-radio-button :value="null">全部</a-radio-button>
          <a-radio-button value="项目计划">项目计划</a-radio-button>
          <a-radio-button value="问题进度">问题进度</a-radio-button>
          <a-radio-button value="需求进度">需求进度</a-radio-button>
          <a-radio-button value="资料库">资料库</a-radio-button>
          <a-radio-button value="设计变更">设计变更</a-radio-button>
          <a-radio-button value="部门需求">部门需求</a-radio-button>
        </a-radio-group>
      </a-space>
      <back-vue></back-vue>
    </div>

    <div class="content">
      <template v-for="item in table.data" :key="item.id">
        <div
          class="df both-side vertical item"
          @click="handleUpdateMessage(item)"
          :class="item.type == 1 ? 'item-read' : ''"
        >
          <div class="">
            <div>{{ item.content }} </div>
            <div>{{ timeStampToTime(item.createTime, 'upload') }}</div>
          </div>

          <!-- 点击查看 -->
          <a-space>
            <a-tooltip placement="top">
              <template #title>
                <span>查看详情</span>
              </template>
              <LinkOutlined class="to-notice" @click="handleToNotice(item)" />
            </a-tooltip>

            <a-tooltip placement="top">
              <template #title>
                <span>复制数据</span>
              </template>
              <CopyOutlined
                class="to-notice"
                @click="handleCopyInfo(item)"
                v-if="item.messageSort === '资料库'"
              />
            </a-tooltip>
          </a-space>
        </div>
      </template>
    </div>

    <div class="df both-side">
      <div></div>
      <a-pagination
        size="small"
        :total="table.total"
        v-model:current="table.pageNum"
        v-model:pageSize="table.lineNum"
        @change="hanldeUpdatePageNum"
        @showSizeChange="hanldeUpdatePageNum"
        :show-total="(total) => `共 ${total} 条`"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, watch } from "vue";
import {
  getPushMessageList,
  updatePushMessage,
} from "@/request/view/pushMessage";
import { useTable } from "@/views/notice/serve/table";
import { useStore } from "vuex";
import { timeStampToTime, debounce, Toast } from "@/utils/index";
import { useRoute, useRouter } from "vue-router";
import { CopyOutlined, LinkOutlined } from "@ant-design/icons-vue";
import backVue from "@/components/back/index.vue";

export default defineComponent({
  components: { backVue, CopyOutlined, LinkOutlined },
  setup() {
    const store = useStore();
    const { id } = store.state.user.user;

    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      searchData,
      deleteRecords,
      hanldeUpdatePageNum,
    } = useTable();

    requestConfig.pull_fn = getPushMessageList;

    initPayload({
      userId: id,
      messageSort: null,
    });

    const handleUpdateMessage = debounce((record) => {
      if (record.type == 1) return;
      updatePushMessage({
        id: record.id,
        type: 1,
      })
        .then((res) => {
          record.type = 1;
          const unReadNum = store.state.unReadNum;
          store.commit("SET_UNREADNUM", unReadNum - 1);
        })
        .catch((err) => {
          console.log(err);
        });
    }, 50);

    const handleCopyInfo = (record) => {
      localStorage.setItem("sky-eye-copy", JSON.stringify(record));
      Toast("success", "数据存储成功", 3);
    };

    const route = useRoute();

    const router = useRouter();

    const handleToNotice = (record) => {
      const { route, query } = record;
      router.push({ path: route, query: JSON.parse(query) });
    };

    const handleSearch = debounce(() => {
      table.pageNum = 1;
      getListData();
    }, 200);

    watch(
      () => route,
      (val) => {
        if (route.path === "/notice") {
          getListData();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      table,
      requestPayload,
      handleCopyInfo,
      handleSearch,
      handleToNotice,
      timeStampToTime,
      handleUpdateMessage,
      hanldeUpdatePageNum,
    };
  },
});
</script>

<style lang="less" scoped>
.notice-pc {
  width: 1280px;
  box-shadow: 0 0 15px 1px #9a9a9a;
  margin: 0 auto;
  height: 100vh;
  padding: 40px 20px 0;
  .title {
    font-size: 26px;
    line-height: 36px;
  }
  .content {
    height: calc(100vh - 200px);
    overflow-y: scroll;
    padding-right: 20px;
    margin-top: 40px;
    margin-bottom: 40px;
    .item {
      font-size: 17px;
      padding: 26px 30px;
      color: #353535;
      border-bottom: 1px solid #e7e7eb;
      letter-spacing: 1px;
    }
    .item-read {
      // color: #9a9a9a;
      background: #dadada;
    }
    .to-notice {
      color: #35b7ad;
      cursor: pointer;
    }
  }
}
</style>
